'use es6'; // These are taken from the old presets API data.

/*
 * type: 'cell'
 */

export const CELL_DATA = {
  displayedFor: ['layouts'],
  gate: '',
  helpText: '',
  hiddenFromCategories: [],
  imageFileName: null,
  is_permanently_locked: false,
  is_special: false,
  label: 'Module Group',
  name: 'cell',
  overrideable: false,
  params: {},
  permanentlyLocked: false,
  special: false,
  type: 'cell'
};
/*
 * type: 'widget_container'
 */

export const WIDGET_CONTAINER_DATA = {
  displayedFor: ['layouts'],
  gate: '',
  helpText: '',
  hiddenFromCategories: [0, 2, 3],
  hiddenFromTemplateTypes: [18],
  imageFileName: null,
  is_permanently_locked: false,
  is_special: false,
  label: 'Flexible Column',
  name: 'flexible_column',
  overrideable: false,
  params: {},
  permanentlyLocked: false,
  special: false,
  type: 'widget_container'
};
/*
 * HACK!!!
 * This is presently a FE only type - do not use with APIs until BE is fixed.
 * { type: 'cell', editable: true } -> { type: 'virtual_cell' }
 * It's basically the same thing as the old `flex_area` type.
 *
 * type: 'virtual_cell'
 *
 * @see {@link https://git.hubteam.com/HubSpot/DesignManagerUI/issues/3971}
 */

export const VIRTUAL_CELL_DATA = Object.assign({}, CELL_DATA, {
  label: 'Drag and Drop Area',
  name: 'virtual_cell',
  hiddenFromCategories: [0, 2, 3],
  hiddenFromTemplateTypes: [18],
  type: 'virtual_cell'
});